import { VFlow } from 'bold-ui'
import { ProcedimentoOdontoSelectModel } from 'components/form/field/select/ProcedimentoOdontoSelectField'
import { resolveName, resolveValue } from 'components/form/final-form/useField'
import React from 'react'
import { FormSpy } from 'react-final-form'
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays'
import { MetaPath } from 'util/metaPath'

import { AdicionarDenteSupranumerarioPopup } from './AdicionarDenteSupranumerarioPopup'
import DentesSupranumerariosTable from './DentesSupranumerariosTable'

export interface EvolucaoDenteSupranumerarioModel {
  data: Date
  local: string
  procedimentos: ProcedimentoOdontoSelectModel[]
  observacao?: string
}

export interface DentesSupranumerariosFieldProps {
  name: MetaPath<EvolucaoDenteSupranumerarioModel[]>
  cidadaoDataNascimento: LocalDate
}

export const trimSupranumeriosObservacao = (values: EvolucaoDenteSupranumerarioModel) =>
  ({
    ...values,
    observacao: values?.observacao?.trim() ? values.observacao : undefined,
  } as EvolucaoDenteSupranumerarioModel)

export default function DentesSupranumerariosField(props: DentesSupranumerariosFieldProps) {
  const { name, cidadaoDataNascimento } = props

  const renderFieldArray = (fieldArrayRenderProps: FieldArrayRenderProps<EvolucaoDenteSupranumerarioModel, any>) => {
    const {
      fields: { push, update, remove },
    } = fieldArrayRenderProps

    const pushEvolucao = (value: EvolucaoDenteSupranumerarioModel) => {
      push({ ...value, data: new Date() })
    }

    return (
      <VFlow>
        <AdicionarDenteSupranumerarioPopup cidadaoDataNascimento={cidadaoDataNascimento} onSubmit={pushEvolucao} />

        <FormSpy subscription={{ values: true }}>
          {(spyProps) => {
            const evolucoes = resolveValue<EvolucaoDenteSupranumerarioModel[]>(spyProps.values, name)

            return (
              <DentesSupranumerariosTable
                cidadaoDataNascimento={cidadaoDataNascimento}
                evolucoes={evolucoes}
                update={update}
                remove={remove}
              />
            )
          }}
        </FormSpy>
      </VFlow>
    )
  }

  return <FieldArray name={resolveName(name)} render={renderFieldArray} />
}
